// extracted by mini-css-extract-plugin
export default {"textInfo":"L4kN1Ms85mmhVrqj8aA3","label":"Td51c92siDidh_q3Js3c"};